import { Tasks } from '../../utils/types';
import { fetchAskerAddressByTask } from '../askers';
import { sendStatusChangeEmail } from '../emails/askerEmails';
import { createEmailLog } from '../email_logs';
import { toast } from 'react-toastify';

class NotificationService {
  private static instance: NotificationService;

  private constructor() {}

  public static getInstance(): NotificationService {
    if (!NotificationService.instance) {
      NotificationService.instance = new NotificationService();
    }
    return NotificationService.instance;
  }

  async notifyAsker(task: Tasks): Promise<void> {
    if (task && task.email) {
      try {
        const askerAddress = await fetchAskerAddressByTask(task.id);
        console.log('Attempting to send email for task:', task);
        const response = await sendStatusChangeEmail({
          task: task,
          address: askerAddress?.address || 'No se proporcionó dirección',
        });

        if (response && response.message === 'Email sent successfully') {
          console.log('Notification email sent successfully');
          toast.success('Correo enviado exitosamente');

          await createEmailLog({
            recipient_email: task.email,
            sender_email: 'soporte@taskyapp.cl',
            label: `task-status-${task.status}`,
            status: 'success',
            task_id: task.id,
          });
        } else {
          throw new Error('Failed to send notification email');
        }
      } catch (error) {
        console.error('Failed to send notification email:', error);
        if (error instanceof Error) {
          if (error.message.includes('Missing required certificate URLs')) {
            toast.error('Error(correos): Faltan certificados del Tasker');
          } else {
            toast.error(`Error(correos): ${error.message}`);
          }
        } else {
          toast.error('Error desconocido al enviar el correo');
        }

        await createEmailLog({
          recipient_email: task.email,
          sender_email: 'soporte@taskyapp.cl',
          label: `task-status-${task.status}`,
          status: 'failure',
          task_id: task.id,
        });
      }
    } else {
      console.log('Cannot send email: task or email is missing', task);
      toast.error('Error: faltan datos para enviar el correo');
    }
  }
}

export default NotificationService.getInstance();
